import React from 'react';
import { motion } from 'framer-motion';
import { BookIcon, PenToolIcon, PrinterIcon, MapPinIcon } from 'lucide-react';
const tomos = [{
  num: 1,
  title: 'Niños Sub-10 Inicial (Parte A)',
  desc: 'El primer contacto con la raqueta. Coordinación óculo-manual, mini-tenis y juegos de éxito inmediato.'
}, {
  num: 2,
  title: 'Niños Sub-10 Inicial (Parte B)',
  desc: 'Scoring adaptado, dirección cruzada, volea de bloqueo y primer torneo interno.'
}, {
  num: 3,
  title: 'Niños Inicial (Sin experiencia)',
  desc: 'Agarre, posición base, derecha y revés básico. El alumno que nunca tocó una raqueta empieza acá.'
}, {
  num: 4,
  title: 'Niños Intermedio 1',
  desc: 'Consistencia, dirección y primer sistema táctico. El niño empieza a jugar puntos reales.'
}, {
  num: 5,
  title: 'Niños Intermedio 2',
  desc: 'Patrón cruzado-paralelo, saque con intención y juego de dobles adaptado.'
}, {
  num: 6,
  title: 'Niños Avanzado',
  desc: 'Juego de red, construcción táctica y preparación para la competencia real.'
}, {
  num: 7,
  title: 'Adolescentes y Adultos Inicial (Sin experiencia)',
  desc: 'El adulto que nunca jugó. Agarre, peloteo básico y primeros puntos en 4 clases.'
}, {
  num: 8,
  title: 'Adolescentes y Adultos Intermedio 1',
  desc: 'Consistencia desde el fondo, dirección cruzada y primer sistema de juego.'
}, {
  num: 9,
  title: 'Adolescentes y Adultos Intermedio 2',
  desc: 'Patrón cruzado-paralelo, topspin y gestión mental entre puntos.'
}, {
  num: 10,
  title: 'Adolescentes y Adultos Avanzado',
  desc: 'Juego de red completo, saque táctico y preparación para torneos de club.'
}, {
  num: 11,
  title: 'Casos Especiales: Adultos Mayores',
  desc: 'Tenis adaptado para cuerpos maduros. Movilidad, equilibrio y bienestar en cancha.'
}, {
  num: 12,
  title: 'Casos Especiales: Reintegro tras Lesiones',
  desc: 'Protocolos de vuelta al juego después de epicondilitis, rodilla, hombro y espalda.'
}];
export function Tomos() {
  return <section className="py-20 bg-offwhite" data-id="element-315">
      <div className="max-w-6xl mx-auto px-4" data-id="element-316">
        <div className="text-center mb-16" data-id="element-317">
          <h3 className="text-4xl md:text-5xl font-display text-charcoal mb-4" data-id="element-318">
            Los 12 Tomos Completos
          </h3>
          <p className="text-xl text-gray-600 font-medium" data-id="element-319">
            Drills graficados · Por nivel y objetivo · Listo para usar mañana
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-320">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 3 * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition-shadow relative overflow-hidden group" data-id="element-321">
              <div className="absolute top-0 right-0 w-24 h-24 bg-tennis-green/5 rounded-bl-[100px] -z-0 transition-transform group-hover:scale-110" data-id="element-322"></div>
              <div className="relative z-10" data-id="element-323">
                <div className="text-clay-orange font-display text-lg mb-2" data-id="element-324">
                  TOMO {tomo.num}
                </div>
                <h4 className="text-xl font-bold text-charcoal mb-3 leading-tight" data-id="element-325">
                  {tomo.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-326">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 bg-white p-6 rounded-2xl border border-gray-200 shadow-sm" data-id="element-327">
          <div className="flex items-center gap-2 font-medium text-charcoal" data-id="element-328">
            <PenToolIcon className="text-clay-orange" size={20} data-id="element-329" />
            <span data-id="element-330">✏️ Ejercicios graficados en cada tomo</span>
          </div>
          <div className="flex items-center gap-2 font-medium text-charcoal" data-id="element-331">
            <BookIcon className="text-clay-orange" size={20} data-id="element-332" />
            <span data-id="element-333">⚡ Sistema "Abrí y Dictás"</span>
          </div>
          <div className="flex items-center gap-2 font-medium text-charcoal" data-id="element-334">
            <PrinterIcon className="text-clay-orange" size={20} data-id="element-335" />
            <span data-id="element-336">📋 Fichas listas para imprimir</span>
          </div>
          <div className="flex items-center gap-2 font-medium text-charcoal" data-id="element-337">
            <MapPinIcon className="text-clay-orange" size={20} data-id="element-338" />
            <span data-id="element-339">🇦🇷 Contenido 100% adaptado a Argentina</span>
          </div>
        </div>
      </div>
    </section>;
}